import { createFileRoute, notFound } from "@tanstack/react-router";
import { CostPageTemplate } from "@/components/CostPageTemplate";
import { getCostPage } from "@/lib/cost-pages";
import { seoHead, serviceSchema, localBusinessSchema } from "@/lib/seo";
import { faqSchema } from "@/components/FAQAccordion";

export const Route = createFileRoute("/cost/$slug")({
  loader: ({ params }) => {
    const page = getCostPage(params.slug);
    if (!page) throw notFound();
    return { page };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { page } = loaderData;
    const path = `/cost/${page.slug}`;
    return seoHead({
      path,
      title: page.title,
      description: page.metaDescription,
      breadcrumbs: [
        { name: "Home", path: "/" },
        { name: "Cost guides", path: "/cost" },
        { name: page.service, path },
      ],
      jsonLd: [
        localBusinessSchema(),
        serviceSchema({
          name: page.service,
          serviceType: page.service,
          description: page.metaDescription,
          areaServed: "East London, E14",
          url: `https://woodseerautos.co.uk${path}`,
        }),
        faqSchema(page.faqs) as Record<string, unknown>,
      ],
    });
  },
  notFoundComponent: () => (
    <div className="mx-auto max-w-2xl px-4 py-20 text-center">
      <h1 className="text-2xl font-bold text-foreground">Cost guide not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">That guide doesn't exist (yet).</p>
    </div>
  ),
  errorComponent: ({ error, reset }) => (
    <div className="mx-auto max-w-2xl px-4 py-20 text-center">
      <h1 className="text-2xl font-bold text-foreground">Couldn't load cost guide</h1>
      <p className="mt-2 text-sm text-muted-foreground">{error.message}</p>
      <button onClick={reset} className="mt-4 rounded-lg bg-primary px-4 py-2 text-sm font-bold text-primary-foreground">Try again</button>
    </div>
  ),
  component: CostPage,
});

function CostPage() {
  const { page } = Route.useLoaderData();
  return <CostPageTemplate content={page} />;
}
